export default class GOBMarquee extends HTMLElement {
  constructor() {
    super();

    this.content = this.querySelector('.marquee__content');
    this.contentClone = this.querySelector('.marquee__content--clone');

    this.animationFrame = null;
    this.offset = 0;

    this.animate = this.animate.bind(this);

    if (!this.content || !this.contentClone) return;
  }

  animate() {
    this.offset += 0.85;
    const contentWidth = this.content.scrollWidth - window.innerWidth;

    if (this.offset > contentWidth) {
      this.offset = 0;
    }

    this.content.style.transform = `translateX(-${this.offset}px)`;

    this.animationFrame = requestAnimationFrame(this.animate);
  }

  connectedCallback() {
    if (!this.content || !this.contentClone) return;

    this.animate();
  }
}

if (!window.customElements.get('gob-marquee')) {
  window.customElements.define('gob-marquee', GOBMarquee);
}